import React, { useState, useEffect } from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";

const Fade = styled.div`
  &.fade-in {
      transition: opacity 1s ease;
  }
  &.fade-out {
      opacity: 0;
      transition: opacity 1s ease;
  }
`;

const MessageContainer = styled.div`
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0px;
  text-align: center;
`;

const Fader = ({rotatingMessages}) => {
  const [fadeProp, setFadeProp] = useState( {fade: 'fade-in'} );
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const timeout = setInterval(() => {
      if (fadeProp.fade === 'fade-in') {
        setFadeProp({
          fade: 'fade-out'
        });
      } else {
        setFadeProp({
          fade: 'fade-in'
        });
        if (messageIndex === (rotatingMessages.length - 1)) {
          setMessageIndex(0);
        } else {
          setMessageIndex(messageIndex + 1);
        }
      }
    }, 5000);
    return () => clearInterval(timeout);
  }, [fadeProp, messageIndex, setMessageIndex, rotatingMessages]);

  return(
    <Fade className={fadeProp.fade}>
      <MessageContainer>
        {rotatingMessages[messageIndex]}
      </MessageContainer>
    </Fade>
  );
};

Fader.propTypes = {
  rotatingMessages: PropTypes.array,
};
Fader.defaultProps = {
  rotatingMessages: [],
};

export default Fader;
